/*
 * Maison Panoramique : petits composants d'interface (aucune dépendance).
 * <mp-gallery> : points de navigation de la galerie mobile (défilement natif, scroll-snap).
 * <mp-compare> : comparateur glissant teinte sombre / teinte claire (piloté par un champ range accessible).
 */
(function () {
  'use strict';

  if (!customElements.get('mp-gallery')) {
    class MpGallery extends HTMLElement {
      connectedCallback() {
        var track = this.querySelector('[data-gallery-track]');
        var dots = this.querySelector('[data-gallery-dots]');
        // 03/11 (audit P3) : sur mobile, la légende de la vue affichée passe sous la galerie, en petit
        var caption = this.querySelector('[data-gallery-caption]');
        var setCaption = function (slide) {
          if (!caption) return;
          var fc = slide && slide.querySelector('figcaption');
          caption.textContent = fc ? fc.textContent.trim() : '';
        };
        if (!track || !dots) return;
        var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
        setCaption(slides[0]);
        if (slides.length < 2) return;
        slides.forEach(function (s, i) {
          var b = document.createElement('span');
          b.className = 'mp-gallery__dot' + (i === 0 ? ' is-active' : '');
          dots.appendChild(b);
        });
        var dotEls = Array.prototype.slice.call(dots.children);
        if (!('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio > 0.6) {
              var i = slides.indexOf(en.target);
              dotEls.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
              setCaption(slides[i]);
            }
          });
        }, { root: track, threshold: [0.6] });
        slides.forEach(function (s) { io.observe(s); });
      }
    }
    customElements.define('mp-gallery', MpGallery);
  }

  if (!customElements.get('mp-compare')) {
    class MpCompare extends HTMLElement {
      connectedCallback() {
        var range = this.querySelector('input[type="range"]');
        if (!range) return;
        var self = this;
        var set = function () { self.style.setProperty('--pos', range.value + '%'); };
        range.addEventListener('input', set);
        set();
      }
    }
    customElements.define('mp-compare', MpCompare);
  }

  /* Bandeau cookies de Shopify : son lien « Politique de confidentialité » pointe vers /fr/policies/privacy-policy,
     qui répond 404. On le dirige vers /policies/privacy-policy (le bandeau est injecté après le chargement). */
  function fixPrivacyLinks(root) {
    (root || document).querySelectorAll('a[href*="/policies/privacy-policy"]').forEach(function (a) {
      var href = a.getAttribute('href');
      var fixed = href.replace(/^(https?:\/\/[^/]+)?\/[a-z]{2}(-[a-z]{2})?\/policies\/privacy-policy/i, '$1/policies/privacy-policy');
      if (fixed !== href) a.setAttribute('href', fixed);
    });
  }
  fixPrivacyLinks();
  if ('MutationObserver' in window) {
    var privacyObserver = new MutationObserver(function () { fixPrivacyLinks(); });
    privacyObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { privacyObserver.disconnect(); }, 20000);
  }

  /* 03/11 (audit C1) : la suite de l'en-tête de collection (texte, réassurances, image) passe juste après la
     section de la grille de produits. Masquée en CSS tant qu'elle n'est pas placée ; sans grille, elle reste en place.
     Éditeur de thème : une section rechargée remplace son ancien bloc déplacé. */
  function placeCollectionMore(root) {
    (root || document).querySelectorAll('[data-mp-chero-more]:not(.is-placed)').forEach(function (more) {
      var grid = document.getElementById('ProductGridContainer');
      var host = grid && grid.closest('.shopify-section');
      if (host && !host.contains(more)) host.after(more);
      more.classList.add('is-placed');
    });
  }
  placeCollectionMore();
  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    document.querySelectorAll('[data-mp-chero-more].is-placed').forEach(function (old) {
      if (id && old.dataset.sectionId === id && !e.target.contains(old)) old.remove();
    });
    placeCollectionMore();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    document.querySelectorAll('[data-mp-chero-more].is-placed').forEach(function (old) {
      if (id && old.dataset.sectionId === id) old.remove();
    });
  });

  /* 03/11 (passe 2, D4) : sur une fiche, le bouton WhatsApp flottant s'efface tant que la galerie ou le configurateur
     est à l'écran (il couvrait le champ hauteur, le titre, « Cadrage conseillé ») ; il revient plus bas sur la page.
     Le lien WhatsApp du bloc d'achat, à côté de l'e-mail, reste disponible. */
  (function waAwayOnProduct() {
    var wa = document.querySelector('.mp-wa');
    var zones = document.querySelectorAll('.mp-pdp__gallery, .mp-pdp__info');
    if (!wa) return;
    if (!zones.length || !('IntersectionObserver' in window)) { wa.classList.remove('is-away'); return; }
    var seen = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
      var on = false;
      seen.forEach(function (v) { if (v) on = true; });
      wa.classList.toggle('is-away', on);
      if (on) wa.setAttribute('tabindex', '-1'); else wa.removeAttribute('tabindex');
    }, { threshold: 0 });
    zones.forEach(function (z) { io.observe(z); });
  })();

  /* 03/11 (audit F3) : une zone qui défile sans contenu cliquable (galerie mobile, planches de l'accueil) doit être
     atteignable au clavier ; tabindex seulement quand elle défile vraiment (pas d'arrêt inutile sur ordinateur). */
  function focusScrollZones() {
    document.querySelectorAll('[data-mp-scroll]').forEach(function (el) {
      if (el.scrollWidth > el.clientWidth + 1) el.setAttribute('tabindex', '0');
      else el.removeAttribute('tabindex');
    });
  }
  if (document.querySelector('[data-mp-scroll]')) {
    focusScrollZones();
    window.addEventListener('resize', focusScrollZones);
    window.addEventListener('load', focusScrollZones);
  }

  /* 03/11 (audit P9) : /pages/contact?sujet=… présélectionne le sujet du formulaire (ajouté s'il n'existe pas). */
  (function presetSubject() {
    var wanted = null;
    try { wanted = new URLSearchParams(window.location.search).get('sujet'); } catch (e) { wanted = null; }
    if (!wanted) return;
    wanted = wanted.slice(0, 80);
    document.querySelectorAll('select[name="contact[Sujet]"]').forEach(function (sel) {
      var opt = Array.prototype.filter.call(sel.options, function (o) { return o.value.toLowerCase() === wanted.toLowerCase(); })[0];
      if (!opt) {
        opt = document.createElement('option');
        opt.value = wanted;
        opt.textContent = wanted;
        sel.appendChild(opt);
      }
      sel.value = opt.value;
    });
  })();

  /* 03/11 (audit E4) : « Gérer mes cookies » rouvre les préférences du bandeau Shopify, pour retirer son
     consentement aussi simplement qu'on l'a donné. Sans l'API Shopify (aperçu, appli absente), le lien reste masqué. */
  function cookiePrefsApi() {
    var b = window.privacyBanner;
    if (b && typeof b.showPreferences === 'function') return b;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.showPreferences === 'function') return cp;
    return null;
  }
  function revealCookieLinks() {
    var ok = !!cookiePrefsApi();
    document.querySelectorAll('[data-mp-cookie-prefs]').forEach(function (btn) { btn.hidden = !ok; });
    return ok;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mp-cookie-prefs]');
    if (!btn) return;
    var api = cookiePrefsApi();
    if (api) { e.preventDefault(); api.showPreferences(); }
  });
  if (!revealCookieLinks()) {
    var tries = 0;
    var poll = window.setInterval(function () {
      tries += 1;
      if (revealCookieLinks() || tries > 40) window.clearInterval(poll);
    }, 500);
  }

  /* Colonne collante plus haute que l'écran (galerie de la fiche motif) : top négatif pour qu'elle défile
     jusqu'à sa dernière vue, puis reste visible tant que la colonne voisine continue. */
  function stickTall() {
    var vh = window.innerHeight;
    document.querySelectorAll('.mp-pdp__gallery').forEach(function (el) {
      var top = Math.min(96, vh - el.offsetHeight - 24);
      el.style.setProperty('--mp-sticky-top', top + 'px');
    });
  }
  if (document.querySelector('.mp-pdp__gallery')) {
    stickTall();
    window.addEventListener('resize', stickTall);
    window.addEventListener('load', stickTall);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(stickTall);
      document.querySelectorAll('.mp-pdp__gallery').forEach(function (el) { ro.observe(el); });
    }
  }
})();
